import { useState } from 'react';

import useIdleCallback from '@glass/web/modules/loading/useIdleCallback';

import SpeedInsightsScript from './SpeedInsightsScript';

/**
 * Deferred Speed Insights Script
 *
 * Delays mounting SpeedInsightsScript until after React hydration completes
 * to prevent React error #421 (Suspense boundary updates during hydration)
 *
 */
function DeferredSpeedInsightsScript() {
  const [isPostHydrationIdleMounted, setIsPostHydrationIdleMounted] = useState(false);

  // This will run the callback after hydration is complete AND when the browser is idle
  useIdleCallback(() => {
    setIsPostHydrationIdleMounted(true);
  });

  if (!isPostHydrationIdleMounted) {
    return null;
  }

  return <SpeedInsightsScript />;
}

export default DeferredSpeedInsightsScript;
